// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: center;
  align-items: stretch;
  background-color: transparent;
  padding: 0 20px;
  color: #333;
  width: 100%;
  margin: 0 auto 10px;
}

.star-column,
.logo-column,
.contact-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header-image {
  width: 100%;
  -o-object-fit: contain;
     object-fit: contain; /* Maintain aspect ratio of the image */
}

.header-phone-btn,
.header-quote-btn {
  background-color: #76bbe9;
  fill: #ffffff;
  border-color: white;
  color: #ffffff;
  position: relative;
  letter-spacing: 0.5px;
  width: -moz-max-content;
  width: max-content;
  transition: transform 0.3s;
  font-size: 1.5rem;
  font-weight: 600;
  border-width: 4px 4px 4px 4px;
  border-style: solid;
  border-radius: 10px 0 10px 0;
  padding: 10px 35px;
  box-shadow: 5px 5px 5px 0 rgba(12, 11, 11, 0.77);

  &:hover {
    background-color: #247a97;
    cursor: pointer;
    transform: scale(0.9);
    border-color: white;
  }
}

.header-quote-btn {
  margin-top: 1rem;
}

.contact-column {
  display: flex;
  font-size: 2.25rem;
  font-weight: 700;
  font-style: italic;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.contact-text {
  font-weight: bolder;
  font-size: 1.75rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.contact-text :first-child {
  margin-bottom: 0;
}

.company-logo {
  width: 100%;
  -o-object-fit: contain;
     object-fit: contain; /* Maintain aspect ratio of the image */
  border-radius: 5rem;
}

.star-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  transform: scale(1.7);
  /* margin: 0; */
  margin-right: -5vw;
}

/* Media query for screens with width ≤ 991px */
@media screen and (max-width: 991px) {
  .header-container {
    padding: 10px 0 5px 0;
  }

  .header {
    grid-template-rows: 1fr 0 0;
  }

  .star-column,
  .logo-column,
  .contact-column {
    width: 100%;
  }

  .menu-toggle {
    display: none;
  }
  .header .header-phone-btn,
  .header-quote-btn {
    padding: 10px 20px;
  }
}

/* Media query for screens with width ≥ 992px */
@media screen and (min-width: 992px) {
  .star-column {
    margin-left: 0;
  }

  .company-logo {
    margin-left: 0;
  }

  .contact-column {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,sBAAmB;KAAnB,mBAAmB,EAAE,uCAAuC;AAC9D;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,gDAAgD;;EAEhD;IACE,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAmB;KAAnB,mBAAmB,EAAE,uCAAuC;EAC5D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;EACA;;IAEE,kBAAkB;EACpB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".header-container {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  justify-content: center;\n  align-items: stretch;\n  background-color: transparent;\n  padding: 0 20px;\n  color: #333;\n  width: 100%;\n  margin: 0 auto 10px;\n}\n\n.star-column,\n.logo-column,\n.contact-column {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.header-image {\n  width: 100%;\n  object-fit: contain; /* Maintain aspect ratio of the image */\n}\n\n.header-phone-btn,\n.header-quote-btn {\n  background-color: #76bbe9;\n  fill: #ffffff;\n  border-color: white;\n  color: #ffffff;\n  position: relative;\n  letter-spacing: 0.5px;\n  width: max-content;\n  transition: transform 0.3s;\n  font-size: 1.5rem;\n  font-weight: 600;\n  border-width: 4px 4px 4px 4px;\n  border-style: solid;\n  border-radius: 10px 0 10px 0;\n  padding: 10px 35px;\n  box-shadow: 5px 5px 5px 0 rgba(12, 11, 11, 0.77);\n\n  &:hover {\n    background-color: #247a97;\n    cursor: pointer;\n    transform: scale(0.9);\n    border-color: white;\n  }\n}\n\n.header-quote-btn {\n  margin-top: 1rem;\n}\n\n.contact-column {\n  display: flex;\n  font-size: 2.25rem;\n  font-weight: 700;\n  font-style: italic;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.contact-text {\n  font-weight: bolder;\n  font-size: 1.75rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n}\n\n.contact-text :first-child {\n  margin-bottom: 0;\n}\n\n.company-logo {\n  width: 100%;\n  object-fit: contain; /* Maintain aspect ratio of the image */\n  border-radius: 5rem;\n}\n\n.star-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  transform: scale(1.7);\n  /* margin: 0; */\n  margin-right: -5vw;\n}\n\n/* Media query for screens with width ≤ 991px */\n@media screen and (max-width: 991px) {\n  .header-container {\n    padding: 10px 0 5px 0;\n  }\n\n  .header {\n    grid-template-rows: 1fr 0 0;\n  }\n\n  .star-column,\n  .logo-column,\n  .contact-column {\n    width: 100%;\n  }\n\n  .menu-toggle {\n    display: none;\n  }\n  .header .header-phone-btn,\n  .header-quote-btn {\n    padding: 10px 20px;\n  }\n}\n\n/* Media query for screens with width ≥ 992px */\n@media screen and (min-width: 992px) {\n  .star-column {\n    margin-left: 0;\n  }\n\n  .company-logo {\n    margin-left: 0;\n  }\n\n  .contact-column {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
